export const ApiResponse = {
    SUCCESS: 200,
    CREATED: 201,
    UNAUTHORIZED: 401,
    NOT_FOUND: 404,
    NOT_VERIFIED: 403,
    CONFLICT: 409,
};